<template>
  <div class="relative">
    <input :id="name" :type="type" :name="name" :required="required" class="input-text" />
    <v-button
      small
      @click="togglePasswordVisibility"
      class="absolute inset-y-0 right-0 w-8"
      :title="title"
      :icon="icon"
      :active="show"
    ></v-button>
  </div>
</template>

<script>
export default {
  props: {
    required: { type: Boolean, default: false },
    name: { type: String, default: '' },
    type: { type: String, default: 'password' },
  },
  data() {
    return { icon: 'far fa-eye', title: 'Passwort einblenden', show: false };
  },
  methods: {
    togglePasswordVisibility() {
      if (this.show) {
        this.type = 'password';
        this.icon = 'far fa-eye';
        this.title = 'Passwort einblenden';
      } else {
        this.type = 'text';
        this.icon = 'far fa-eye-slash';
        this.title = 'Passwort ausblenden';
      }
      this.show = !this.show;
    },
  },
};
</script>
